import { Sparkles } from 'lucide-react';
import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';
import { AiTaskPanel } from './task/AiTaskPanel';

/**
 * ШІ-шар (М17, розділ 6 плану): каталог ШІ-1…ШІ-28 зі станом і перемикачами, журнал ШІ-дій з рішенням і оцінкою,
 * контент-плани (ШІ-25) й кейси для маркетингу (ШІ-28), пакет знань фірми; для адміністратора — шаблони запитів,
 * ШІ-учасники (ШІ-23), якість (еталони й регресійні перевірки) і налаштування (режим, бюджет, аварійне вимкнення).
 * У картці задачі — розділ «ШІ-помічник»: підсумок (ШІ-3), перевірка постановки (ШІ-2), для матеріалів — ШІ-26/27.
 */
const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const aiModule: ModuleDefinition = {
  key: 'ai',
  label: 'ШІ-помічники',
  icon: Sparkles,
  basePath: '/ai',
  scope: 'ai:use',
  order: 65,
  routes: [
    {
      ...page(() => import('./AiLayout')),
      children: [
        { index: true, ...page(() => import('./pages/FeaturesPage')) },
        { path: 'runs', ...page(() => import('./pages/RunsPage')) },
        { path: 'content-plans', ...page(() => import('./pages/ContentPlansPage')) },
        { path: 'content-plans/:planId', ...page(() => import('./pages/ContentPlanPage')) },
        { path: 'cases', ...page(() => import('./pages/CaseProposalsPage')) },
        { path: 'knowledge', ...page(() => import('./pages/KnowledgePage')) },
        { path: 'templates', ...page(() => import('./pages/TemplatesPage')) },
        { path: 'participants', ...page(() => import('./pages/ParticipantsPage')) },
        { path: 'quality', ...page(() => import('./pages/QualityPage')) },
        { path: 'settings', ...page(() => import('./pages/SettingsPage')) },
      ],
    },
  ],
  nav: [{ to: '/ai', label: 'ШІ-помічники', icon: Sparkles }],
  task: {
    // Другорядний розділ: згорнутий, доки його не відкриють.
    panel: { title: 'ШІ-помічник', icon: Sparkles, Component: AiTaskPanel, defaultOpen: false },
  },
};

export default aiModule;
